import React, { useMemo, useCallback } from "react";
import Avatar from "../../../../../components/Avatar";
import { Grid, Tooltip } from "@mui/material";
import moment from "moment";
import CustomizedProgressBars from "../../../../board/components/progressBar/ProgressBar";
import { useNavigate } from "react-router-dom";
import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import { createAvtarName, hasImage } from "../../../../../utils";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { useSearchParams } from "react-router-dom";

function ShowWorklog({ worklog, boardName }) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const boardKey = boardName?.data?.data?.responseData?.key;
  const [data, updateSearchParams] = useCustomSearchParams("card_id");
  const isMobile = useResponsive("down", "md");

  // Memoize board data
  const boardData = useMemo(
    () => ({
      boardId: boardName?.data?.data?.responseData?.board_id,
      boardKey: boardName?.data?.data?.responseData?.key?.toUpperCase(),
      boardName: boardName?.data?.data?.responseData?.board_name,
    }),
    [boardName]
  );

  // Memoize avatar styles
  const avatarStyles = useMemo(
    () =>
      !hasImage(worklog?.user_image)
        ? {
            bgcolor: worklog?.user_profile_color?.background,
            color: worklog?.user_profile_color?.text,
          }
        : {},
    [worklog?.user_image, worklog?.user_profile_color]
  );

  const formattedDate = useMemo(
    () =>
      moment
        .utc(worklog?.created_at)
        .local()
        .format("MMMM D, YYYY [at] h:mm A"),
    [worklog?.created_at]
  );

  const openBoard = useCallback(() => {
    navigate(`/board/${boardData.boardId}`);
  }, [navigate, boardData.boardId]);

  const handleCardClick = useCallback((event) => {
    const isModifierPressed = event.metaKey || event.ctrlKey || event.shiftKey;
    const url = `/feeds/${boardKey}/${boardKey}-${worklog?.card_id}?${searchParams.toString()}`;
    if (isModifierPressed) {
      window.open(url, "_blank");
      event.stopPropagation();
      return;
    }
    navigate(url);
  }, [updateSearchParams, worklog?.card_id]);

  if (!worklog) return null;

  return (
    <Grid
      container
      spacing={2}
      sx={{
        width: isMobile
          ? "calc(100% - 10px) !important"
          : "calc(100% + 16px) !important",
      }}
      className="worklog-item d-flex justify-content-space-between">
      <Grid
        item
        xs={isMobile ? 12 : 9}
        sx={{ paddingLeft: isMobile && "8px !important" }}>
        <div className="d-flex w-100">
          <Avatar
            // key={`user-avtar-${el.user_id}`}
            username={`${worklog?.username}`}
            user_image={worklog?.user_image}
            title={`${worklog?.username}`}
            className="user-avtar-dropdown user-avatar mr-8"
            style={avatarStyles}>
            {createAvtarName(`${worklog?.username}` || "")}
          </Avatar>
          <div className="w-100">
            <div className="d-flex justify-content-space-between ">
              <div
                className={
                  isMobile
                    ? "d-flex align-items-center flex-dir-col"
                    : "d-flex align-items-center"
                }>
                <div>
                  <Tooltip title={boardData.boardName}>
                    <a
                      className="board-anquor cursor-pointer underline"
                      onClick={openBoard}>
                      {boardData.boardKey}
                    </a>
                  </Tooltip>
                  -
                  <a
                    className="board-anquor cursor-pointer mr-1 underline"
                    onClick={handleCardClick}>
                    {worklog?.card_id}:
                  </a>
                </div>
                <p className="worklog-title mr-2">{worklog?.username}</p>
              </div>
              <p className="hours">{worklog?.hour_spent} Hours</p>
            </div>
            <p
              className="worklog-worklog comment-content"
              dangerouslySetInnerHTML={{
                __html: worklog?.history_text,
              }}></p>
            <p
              className="worklog-worklog"
              dangerouslySetInnerHTML={{
                __html: worklog?.work_performed,
              }}></p>
          </div>
        </div>
      </Grid>
      <Grid
        item
        xs={isMobile ? 12 : 3}
        sx={{ paddingTop: isMobile && "0px !important" }}>
        <div className={isMobile ? "" : "right-details"}>
          <div className="d-flex justify-content-end">
            <p className="worklog-status">{worklog?.workflow_step}</p>
          </div>
          <p
            className="worklog-date-time"
            style={{ marginTop: isMobile && "4px" }}>
            {formattedDate}
          </p>
          <CustomizedProgressBars
            allocatedHours={worklog?.allocated_hours}
            hoursSpent={worklog?.response_object?.new_key?.total_hour_spent}
          />
        </div>
      </Grid>
    </Grid>
  );
}

const isChangeFeedWorklog = (prevProps, nextProps) => {
  return (
    prevProps.worklog.card_id === nextProps.worklog.card_id &&
    prevProps.worklog.username === nextProps.worklog.username &&
    prevProps.worklog.hour_spent === nextProps.worklog.hour_spent &&
    prevProps.worklog.workflow_step === nextProps.worklog.workflow_step &&
    prevProps.worklog.work_performed === nextProps.worklog.work_performed &&
    prevProps.worklog.allocated_hours === nextProps.worklog.allocated_hours
  );
};
export default React.memo(ShowWorklog, isChangeFeedWorklog);
